<template>
  <template v-if="!inline">
  <!-- UI -->
  <nav class="custom-nav blue-grey darken-3 hide-on-small-only"></nav>

  <nav class="nav-extended blue-grey darken-3 hide-on-small-only">
    <div class="nav-wrapper container">
      <a href="#!" class="brand-logo" @click.prevent="handleActive(home)">{{ home?.name }}</a>
      <ul class="right hide-on-med-and-down">
        <li v-for="tab in tabs" :key="tab.id" :class="{ 'active blue-grey darken-2': tab.id == currTab.id }">
          <a href="#" @click.prevent="handleActive(tab)">{{ tab.title }}</a>
        </li>
      </ul>
    </div>
    <div class="nav-content container">
      <a class="btn-floating btn-large halfway-fab waves-effect waves-light left red darken-2" title="Close"
        @click.prevent="handleRestart()">
        <i class="material-icons white-text">close</i>
      </a>
      <br />
    </div>
  </nav>

  <!-- Mobile only  -->
  <nav class="blue-grey darken-4 hide-on-large-only">
    <ul class="tabs tabs-transparent">
      <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'active': tab.id == currTab.id }">
        <a href="#" @click.prevent="handleActive(tab)">{{ tab?.title?.split(" ")[0] }}</a>
        <!-- <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a> -->
      </li>
    </ul>
  </nav>

  <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i>
            Dashboard</small></router-link>
        <router-link to="/auth" class="breadcrumb blue-grey-text text-darken-3"><small> Authorization
            Home</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Review</small></span>
      </div>
    </div>
  </nav>
  </template>

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->


  <div :class="[inline ? 'auth-inline-detail' : 'container', 'sba-slide-in']">
    <br v-if="!inline" />
    <div class="auth-inline-leader" v-if="inline && encounter">
      <div class="auth-inline-leader-main">
        <span class="auth-inline-status" :class="{ 'is-waiting': encounter.claims?.length }">
          <i class="material-icons">{{ encounter.claims?.length ? "pending_actions" : "verified_user" }}</i>
        </span>
        <div>
          <label class="active teal-text">Authorization Request</label>
          <h5>{{ encounter.name.toUpperCase() }}</h5>
          <p>
            <span>{{ encounter?.provider?.name || "Provider not recorded" }}</span>
            <span class="auth-inline-dot"></span>
            <strong>{{ encounter.enrollee_number }}</strong>
          </p>
          <div class="auth-inline-meta-chips">
            <span>{{ encounter.scheme?.name?.toUpperCase() || "NO SCHEME" }}</span>
            <span>{{ showAgeSex(encounter?.dob, encounter?.sex)?.toUpperCase() }}</span>
            <span>
              {{
                new Date(encounter?.encounter_date).toLocaleString(undefined, {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })
              }}
            </span>
            <span class="is-locked" v-if="claimsLocked">
              <i class="material-icons">lock</i>{{ claimsLockLabel }}
            </span>
            <span class="is-locked" v-else-if="encounterAddLocked">
              <i class="material-icons">lock</i>{{ addAuthLockLabel }}
            </span>
          </div>
        </div>
      </div>

      <button class="btn-flat auth-inline-close" title="Close" @click.prevent="handleRestart">
        <i class="material-icons left">close</i>Close
      </button>
    </div>

    <div class="section center" :class="{ 'auth-inline-switch': inline }">
      <span v-for="tab in tabsState" :key="tab.id" :class="{
        'tab-custom-active': tab.id == currState.id,
        'tab-custom': tab.id != currState.id,
        'left blue-text': tab.title == 'Back',
      }" @click="handleActiveState(tab)">
        <i class="material-icons left" v-if="tab.title == 'Back'">arrow_back</i> {{ tab.title }}
      </span>
    </div>

    <div class="auth-created-guide" v-if="inline && justCreated && encounter">
      <div class="auth-created-guide-icon">
        <i class="material-icons">verified</i>
      </div>
      <div class="auth-created-guide-copy">
        <span>Authorization request created</span>
        <p>
          You are now viewing the newly registered authorization detail for
          <strong>{{ encounter.name.toUpperCase() }}</strong>. Review the request below, or return to the main request page.
        </p>
      </div>
      <button type="button" class="auth-created-guide-action" @click.prevent="handleRestart">
        <i class="material-icons">arrow_back</i>
        <span>Go Back Home</span>
      </button>
    </div>

    <LoadingDiv v-if="!isReady" />

    <div v-else>
      <div v-if="encounter">

        <div class="section">
          <div class="card z-depth-0 grey lighten-4 auth-inline-inner-card">
            <template v-if="!inline">
              <br />
              <span class="new badge left" data-badge-caption="Scheme">{{
                encounter.scheme.name.toUpperCase()
              }}</span>

              <!-- Encounter -->
              <div class="card-content">
                <div class="row">
                  <div class="col s8">
                    <p>{{ encounter?.provider?.name }}</p>
                    <h5>
                      {{ encounter.name.toUpperCase() }}
                      <sup><small><span class="chip black-text">{{
                        showAgeSex(encounter?.dob, encounter?.sex)
                            }}</span></small></sup>
                      <!-- &nbsp; <a href="#" class="orange-text"><i class="material-icons teal lighten-4" title="go back"
                          @click.prevent="handleRestart()">clear</i></a> -->
                    </h5>
                   <h5> <small> ({{ encounter.enrollee_number }})</small> </h5>
                    <p>
                      <br />
                      <span class="chip black white-text">
                        {{
                          new Date(encounter?.encounter_date).toLocaleString(undefined, {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="col s4">
                    <img :src="encounter.profile_img" width="192" class="circle responsive-img right"
                      v-if="encounter.profile_img" />
                    <img :src="`https://ui-avatars.com/api/?name=${encounter.name}&size=128`" width="192"
                      class="circle responsive-img right" v-else />
                  </div>
                </div>
              </div>
            </template>

            <!-- Entire Provider (diagnosis, claims) Display starts here -->
            <template v-if="currState.title == 'Review'">
              <div class="card grey lighten-4 auth-inline-review-card">

                <div id="claim"></div>

                <!-- Display Diagnosis -->
                <div class="auth-diagnosis-card">
                  <div class="auth-diagnosis-icon">
                    <i class="material-icons">bookmark_border</i>
                  </div>
                  <div class="auth-diagnosis-copy">
                    <span>Diagnosis</span>
                    <p v-if="encounter?.diagnosis">{{ encounter?.diagnosis }}</p>
                    <p class="is-muted" v-else>Not recorded</p>
                  </div>
                </div>

                <!-- Approvals (use original un-altered enrollee info)-->
                <div class="card" v-if="enrolleeDefault?.claims?.find(x => (x.authorization === 'y') || (x.authorization == 'z' && x.status == 'd'))">
                  <ol class="collection">
                    <span v-for="claim in enrolleeDefault.claims.slice().reverse()" :key="claim.id">

                      <!-- approved -->
                      <span v-if="claim.authorization == 'y'">
                        <li class="collection-item"
                          :class="{ 'grey lighten-2': claim.sent_price == 0, 'green lighten-4': claim.sent_price != 0 }"
                          v-if="claim.sent_price === claim.approved_price">
                          <b>{{ claim.item }}</b> x {{ claim.sent_qty }}
                          ({{
                            toMoney(claim.sent_price)
                          }}) <span v-if="claim.sent_price != 0">-> (Approved)</span> ->
                          <span class="blue-text tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                            v-if="claim.comment">({{
                              claim.authorization_code }})</span>
                          <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                          <span class="secondary-content pointable"
                            :class="{ 'black-text': claim.sent_price == 0, 'green-text': claim.sent_price != 0 }"
                            :title="claim.sent_price == 0 ? 'Completed' : 'Approved'">
                            <i class="material-icons hide-on-small-only">check_circle</i>
                            <i class="tiny material-icons hide-on-med-and-up">check_circle</i>
                          </span>
                        </li>
                        <li class="collection-item blue lighten-4" v-else>
                          <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged:
                          {{
                            toMoney(claim.sent_price)
                          }}) -> x {{ claim.approved_qty }} (Approved: <b>{{ toMoney(claim.approved_price) }}</b>) ->
                          <span class="blue-text text-darken-4 tooltipped pointable" data-position="top"
                            :data-tooltip="claim.comment" v-if="claim.comment">({{
                              claim.authorization_code }})</span>
                          <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                          <span class="secondary-content green-text pointable" title="Approved">
                            <i class="material-icons hide-on-small-only">check_circle</i>
                            <i class="tiny material-icons hide-on-med-and-up">check_circle</i>
                          </span>
                        </li>
                      </span>

                      <!-- declined -->
                      <li class="collection-item red lighten-4"
                        v-if="claim.authorization == 'z' && claim.status == 'd'">
                        <s>
                          <span class="tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                            v-if="claim.comment">
                            <b>{{ claim.item }}</b> x
                            {{ claim.sent_qty }} (Charged: {{
                              toMoney(claim.sent_price)
                            }})
                          </span>

                          <span v-else>
                            <b>{{ claim.item }}</b> x
                            {{ claim.sent_qty }} (Charged: {{
                              toMoney(claim.sent_price)
                            }})
                          </span>
                        </s>

                        <span class="secondary-content red-text pointable" title="Declined">
                          <i class="material-icons hide-on-small-only">cancel</i>
                          <i class="tiny material-icons hide-on-med-and-up">cancel</i>
                        </span>
                      </li>
                      <div class="divider"></div>
                    </span>
                  </ol>

                  <!-- Add new Auth -->
                </div>

                <!-- Add new Auth -->
                <a class="btn-floating btn-large halfway-fab waves-effect waves-light"
                  :class="{ 'disabled': isSubmitting || encounter.claims.length || lock || addAuthLocked, 'red': addAuth, 'blue': !addAuth }"
                  :title="addAuthLocked ? addAuthLockLabel : `${addAuth ? 'cancel' : 'Add Authorization'}`" @click.prevent="handleAddAuth">
                  <i class="material-icons">{{ addAuth ? "cancel" : "add" }}</i>
                </a>

                <!-- Claims Display Card -->
                <div class="card grey lighten-5 auth-inline-items-card" v-if="encounter.claims.length">
                  <div class="card-content">
                    <span class="card-title">Item(s)

                      <!-- <a
                    class="btn-medium waves-effect waves-light blue lighten-2 secondary-content chip right"><i
                      class="material-icons white-text" @click.prevent="handleAddAuth"
                      title="add New Item">add</i>
                    </a> -->

                    </span>

                    <!-- Auth Request -->
                    <ol id="item-list" class="collection">
                      <li class="collection-item auth-line-item" v-for="claim in encounter.claims.slice().reverse()" :key="claim.id">
                        <template v-if="encounter.status == 'd'">

                          <!-- Deleted Encounter Items -->
                          <span class="auth-line-copy">
                            <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})</s>
                            <b><span class="info-item tooltipped pointable" data-position="top"
                                :data-tooltip="claim.comment">
                                <i class="material-icons grey-text">help</i>
                              </span></b>

                            <!-- Authorizations (delete) -->
                            <span v-if="claim.authorization == 'y'">
                              => <s> ({{ claim.authorization_code }}) </s>
                            </span>
                          </span>

                        </template>

                        <template v-else>
                          <!-- Pending Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'z' && claim.status == 'a'">
                            <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} (₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})

                            <!-- Reviewed claim -->
                            <span class="brown-text" v-if="claim.sent_price != claim.approved_price">
                              <b> =></b>

                              <span v-if="claim.sent_qty != claim.approved_qty"> x {{ claim.approved_qty }} </span>

                              <b> (₦{{
                                Number(claim.approved_price)
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }})<span class="info-item tooltipped pointable" data-position="top"
                                  :data-tooltip="capWords(claim.comment)">
                                  <i class="material-icons grey-text">help</i>
                                </span></b>
                            </span>

                            <!-- Authorizations (active) -->
                            <span v-if="claim.authorization == 'y'">
                              => ({{ claim.authorization_code }})
                              <span class="info-item tooltipped secondary-content pointable" data-position="top"
                                :data-tooltip="claim?.slug">
                                <i class="material-icons">lock_outline</i>
                              </span>
                            </span>

                            <!-- Actions -->
                            <span class="line-item-actions" v-if="!isSubmitting && !claimsLocked">
                              <a href="#" class="secondary-content cancel-item"
                                @click.prevent="handleReview(claim, 'delete')" title="delete">
                                <i class="material-icons hide-on-small-only" :class="{
                                  'grey-text': deleteClaim?.id !== claim.id,
                                  'red-text': deleteClaim?.id === claim.id,
                                }">cancel</i>
                                <i class="tiny material-icons hide-on-med-and-up" :class="{
                                  'grey-text': deleteClaim?.id !== claim.id,
                                  'red-text': deleteClaim?.id === claim.id,
                                }">cancel</i>
                              </a>

                              <a href="#" class="secondary-content edit-item"
                                @click.prevent="handleReview(claim, 'edit')" title="edit">
                                <i class="material-icons hide-on-small-only" :class="{
                                  'grey-text': editClaim?.id !== claim.id,
                                  'blue-text': editClaim?.id === claim.id,
                                }">edit</i>
                                <i class="tiny material-icons hide-on-med-and-up" :class="{
                                  'grey-text': editClaim?.id !== claim.id,
                                  'blue-text': editClaim?.id === claim.id,
                                }">edit</i>
                              </a>
                            </span>
                          </span>

                          <!-- Deleted Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'z' && claim.status == 'd'">
                            <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})</s>
                            <b><span class="info-item tooltipped pointable" data-position="top"
                                :data-tooltip="capWords(claim.comment)">
                                <i class="material-icons grey-text">help</i>
                              </span></b>

                            <!-- Actions -->
                            <span class="line-item-actions">
                              <a href="#" class="secondary-content reset-item" @click.prevent="handleReset(claim)"
                              v-if="!claimsLocked"
                              title="reset"><i class="small material-icons grey-text">refresh</i></a>
                            </span>
                          </span>
                        </template>
                      </li>
                    </ol>

                    <!-- Claims Submit -->
                    <div>
                      <!-- Total -->
                      <ul id="item-list" class="collection">
                        <li class="collection-item pull-right">
                          <b>Total</b> <em>(for approval)</em>:
                          <b><span class="red-text">₦{{ totalApproved(encounter?.claims) }}</span></b>
                        </li>
                      </ul>

                      <div id="edit"></div>

                      <br />

                      <!-- Submit -->
                      <div class="row">
                        <a class="waves-effect waves-light btn-large col s12 m2 left auth-inline-back-action" @click.prevent="handleRestart">
                          <i class="medium material-icons left">chevron_left</i>Back
                        </a>

                        <!-- Breaker -->
                        <span class="co1 m7"></span>
                        <!-- Submit -->
                        <button class="waves-effect waves-light btn-large green col s12 m3 right" :class="{
                          disabled: isSubmitting || claimsLocked,
                        }" :disabled="isSubmitting || claimsLocked" @click.prevent="openApproveConfirm"><i class="large material-icons left">check_circle</i>{{
                          isSubmitting ? "Completing ..." : "Complete" }}
                        </button>
                      </div>

                      <!-- Confirmation -->
                      <Teleport to="body">
                        <div class="auth-inline-confirm-layer" v-if="showApproveConfirm">
                          <div class="auth-inline-confirm-card">
                            <div class="auth-inline-confirm-content">
                              <h4>{{ alertTitle }}</h4>
                              <p>{{ alertMessage }}</p>
                            </div>
                            <div class="auth-inline-confirm-actions">
                              <button type="button" @click.prevent="handleConfirm(false)">Cancel</button>
                              <button type="button" @click.prevent="handleConfirm(true)">Confirm</button>
                            </div>
                          </div>
                        </div>
                      </Teleport>
                    </div>
                  </div>
                </div>

                <!-- Sumbmitting -->
                <div class="progress" v-if="isSubmitting">
                  <div class="indeterminate"></div>
                </div>

                <!-- <div class="white"><br /></div> -->

                <!-- Add claim -->
                <transition name="auth-add-slide">
                  <div class="auth-inline-add-shell" ref="addAuthPanel" v-if="addAuth">
                    <AddAuthItem
                      :turl="{ sid: encounter?.scheme_id, pid: encounter?.provider_id, opid: encounter?.provider?.opid }"
                      :reset="error" @update="handleAddAuthUpdate" />
                  </div>
                </transition>

                <!-- Edit and Delete Claims -->
                <div class="card" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }"
                  v-if="!claimsLocked && (editClaim || deleteClaim)">
                  <div class="card-content">
                    <div class="row">
                      <form class="col s12" @submit.prevent="handleUpdate()">
                        <div class="row">
                          <!-- Main  hide-on-small-only -->
                          <div class="input-field col s12 m6">
                            <input v-model="claim" id="claim" type="text" :readonly="!!deleteClaim" @focus="!deleteClaim && handleClear()" />
                            <label class="active" for="claim">Item</label>
                          </div>
                          <!-- Continue -->
                          <div class="input-field col s6 m3">
                            <input v-model="qty" @input="handlePricing" id="qty" type="number" :disabled="!!deleteClaim" />
                            <label class="active" for="qty">Quantity</label>
                          </div>
                          <div class="input-field col s6 m3">
                            <input v-model="amt" id="amt" type="number" readonly :disabled="!!deleteClaim" />
                            <label class="active" for="amt">Amount Charged</label>
                          </div>
                          <!-- Comment -->
                          <div class="input-field col s12">
                            <input v-model="comment" id="comment" type="text" required />
                            <label class="active" for="comment">Comment</label>
                          </div>

                          <div class="input-field col s12">
                            <a class="waves-effect waves-light btn col s12 m2 auth-inline-back-action auth-inline-item-close-action"
                              @click.prevent="handleClear()">
                              <i class="medium material-icons left">close</i>Close
                            </a>

                            <!-- Breaker -->
                            <span class="co1 m7"></span>

                            <!-- OK -->
                            <button class="waves-effect waves-light btn col s12 m3 right"
                              :class="{ 'indigo darken-2': editClaim?.id, 'red darken-2': deleteClaim?.id }">
                              <i class="medium material-icons left">{{
                                editClaim?.id ? "sync" : "cancel"
                              }}</i>{{ editClaim?.id ? "Edit Item" : "Delete Item" }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

              </div>
            </template>

            <!-- Benefits -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'Benefits'">
              <BenefitsDiv
                v-if="benefitPlanId(encounter) && encounter?.client_id"
                :pid="benefitPlanId(encounter)"
                :cid="encounter.client_id"
              />
            </div>

            <!-- History -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'History'">
              <HistoryAuth :enrolleeNumber="encounter.enrollee_number"
                :scheme-id="encounter.scheme_id || encounter.scheme?.id" />
            </div>

            <!-- Utilization -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'Utilization'">
              <UtilizationInsight :encounter="encounter" @reset="handleActiveState(tabsState[0])" />
            </div>

          </div>
        </div>

      </div>

      <div class="section center" v-if="!encounter">
        <h6><img src="@/assets/img/no-user.png" width="256" class="circle responsive-img" /></h6>
      </div>


    </div>

  </div>
</template>

<script>
import { ref, onMounted, onUpdated, computed, watchEffect, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { toMoneyFx } from "@/composables/calFunction/cal.js";
import { ageSex } from "@/composables/fxLibrary/coreFx";
import postItem from "@/composables/postItem";
import getItem from "@/composables/getItem";
import AddAuthItem from "@/components/auth/AddAuthItemComponent.vue";
import BenefitsDiv from "@/components/plan/ShowBenefitComponent.vue";
import HistoryAuth from "@/components/auth/HistoryAuthComponent.vue";
import UtilizationInsight from "@/components/insight/UtilizationInsightComponent.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import { ID_NUMBER, ABBR } from '@/laravel/config';
import { capWordsFx } from "@/composables/fxLibrary/coreFx.js";
import { siloMode } from '@/laravel/config';
import M from "materialize-css";


export default {
  name: "AuthInlineReviewComponent",
  props: {
    encounterId: [String, Number],
    inline: {
      type: Boolean,
      default: true,
    },
    justCreated: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close", "saved"],
  components: { LoadingDiv, AddAuthItem, BenefitsDiv, HistoryAuth, UtilizationInsight },
  setup(props, context) {
    const lock = ref(false);
    const response = ref(null);
    const enrolleeDefault = ref([]);
    const selectedItem = ref(null);
    const isReady = ref(false);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const alertTitle = ref("Confirm");
    const alertMessage = ref("Are you sure? Kindly confirm items for accuracy. Once submitted, changes cannot be made.");
    const home = ref(null);
    const tabs = ref([]);
    const currTab = ref(null);
    const tabsState = ref([]);
    const currState = ref(null);
    const error = ref(false);
    const addAuth = ref(false);
    const editClaim = ref(null);
    const deleteClaim = ref(null);
    const standard = ref(null);
    const comment = ref(null);
    const claim = ref(null);
    const qty = ref(null);
    const amt = ref(null);
    const getResource = ref(null);
    const postResource = ref(null);
    const addAuthPanel = ref(null);
    const showApproveConfirm = ref(false);

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // start
    onMounted(() => {
      // page name
      if (!props.inline) {
        document.title = "Approval Authorization | EasyHMO";
      }
    });

    // sort silo
    onMounted(() => {
      // sort
      getResource.value = getItem;
      postResource.value = postItem;
    });

    // start
    const validityChecker = (val) => {
      // only for remote calls
      if (siloMode) return;

      // checker
      if (ID_NUMBER !== val?.payer_id) {
        // return
        handleRestart();
      }
    }

    // start
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Pre-Auth", title: "Request", icon: "arrow_back", url: "auth", hash: null, });
      tabs.value.push({ id: 2, name: "Pre-Auth", title: "Add Auth", icon: "add_circle", url: "authAdd", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Request"));
      // set home
      home.value = tabs.value.find(x => x.title.includes("Request"));
    });


    onMounted(() => {
      // load tab
      // tabsState.value.push({ id: 1, title: "Back" });
      tabsState.value.push({ id: 2, title: "Review" });
      tabsState.value.push({ id: 3, title: "Benefits" });
      tabsState.value.push({ id: 4, title: "History" });
      tabsState.value.push({ id: 5, title: "Utilization" });
      // set default
      currState.value = tabsState.value[0]; // start from Review
    });

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };

    // handle curr status
    const handleActiveState = (tab) => {
      // update show and components
      currState.value = tab;
    };

    const benefitPlanId = (val) => {
      return val?.plan_id || val?.plan?.id || val?.principal?.plan_id || val?.principal?.plan?.id || null;
    };

    const claimsLocked = computed(() => {
      const status = encounter.value?.cluster?.status;
      return siloMode && status && status !== "q";
    });

    const claimsLockLabel = computed(() => {
      const status = encounter.value?.cluster?.status;
      return status === "p" ? "Claims submitted" : "Claims closed";
    });

    const encounterAddLocked = computed(() => {
      const status = encounter.value?.status;
      return siloMode && status && status !== "q";
    });

    const addAuthLocked = computed(() => {
      return claimsLocked.value || encounterAddLocked.value;
    });

    const addAuthLockLabel = computed(() => {
      if (claimsLocked.value) {
        return claimsLockLabel.value;
      }

      return "Encounter submitted";
    });

    const moveToSection = (section) => {
      if (props.inline) {
        setTimeout(() => {
          document.getElementById(section)?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 50);
        return;
      }

      router.push({ hash: `#${section}` });
    };

    // get function
    const getSingleItemFromApi = (table, id) => {
      (async () => {
        const { res, err } = await getResource.value(table, id);

        if (res.value) {

          const detailPayload = res.value.data;

          // set default
          enrolleeDefault.value = JSON.parse(JSON.stringify({
            ...detailPayload,
            claims: detailPayload.auth_history || detailPayload.claims || [],
          }));

          // get started
          let authEncounter = {
            ...detailPayload,
            claims: detailPayload.vetting_claims || detailPayload.claims || [],
          };

          // oneProvider still uses the older generic encounter payload
          if (!siloMode) {
            authEncounter.claims = authEncounter.claims.filter(x => x.status === "a" && x.authorization === "z");
          }

          // merge
          response.value = authEncounter;

          // SECURITY CHECKPOINT
          validityChecker(response.value);

          // // encounter
          // responseEncounter.value = res.value.data;
          // // auths
          // responseAuths.value = res.value.data.claims.filter(
          //   (x) => x.authorization != "n"
          // );
          // // sort auths
          // responseAuths.value.sort((a, b) => {
          //   return a.authorization.localeCompare(b.authorization);
          // });
        } else {
          error.value = err.value;
        }

        // page is ready
        isReady.value = true;
      })();
    };

    // toolTip
    const toolTip = () => {
      var elems = document.querySelectorAll(".tooltipped");
      M.Tooltip.init(elems, {});
    };

    // restart toolTip
    const restartComments = () => {
      // load comment
      setTimeout(() => {
        toolTip();
      }, 2000);
    };

    // load after data loads and updates
    watchEffect(() => {
      if (response.value) {
        restartComments();
      }
    });

    // starter
    onMounted(() => {
      // get items from function
      getSingleItemFromApi(siloMode ? "encounter/auth/detail" : "integration/oneprovider/auth", props.encounterId);
    });

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    // add up
    const totalApproved = (claims) => {
      let total = 0;
      claims?.forEach((x) => {
        if (x.approved_price && x.status === "a" && x.authorization === "z") {
          total = Number(total) + Number(x.approved_price);
        }
      });
      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // to Money
    const toMoney = (val) => {
      return toMoneyFx(val);
    }

    // ageSex
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    // scrollbar
    const resetScrollBar = () => {
      // Restore scrollbar (insurance)
      document.body.style.overflow = 'auto';
    };

    // alert
    onMounted(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {});

    });

    // alert
    onUpdated(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {});

    });

    // clear
    const handleClear = () => {
      // clear all
      claim.value = null;
      amt.value = null;
      qty.value = null;
      standard.value = null;
      comment.value = null;
      editClaim.value = null;
      deleteClaim.value = null;
    }

    // handle edit
    const handleReview = (val, type) => {
      if (claimsLocked.value) {
        return;
      }

      // refine claim
      claim.value = val.item;
      amt.value = val.sent_price;
      qty.value = val.sent_qty;
      standard.value = val.standard_price;

      // store all
      if (type === "edit") {
        if (editClaim.value?.id === val.id) {
          // clear all
          editClaim.value = null;
          handleClear();
          return;
        }
        comment.value = val.comment;
        editClaim.value = val;
        // clear delete lurking around
        deleteClaim.value = null;
      } else if (type === "delete") {
        if (deleteClaim.value?.id === val.id) {
          // clear all
          deleteClaim.value = null;
          handleClear();
          return;
        }
        comment.value = null;
        deleteClaim.value = val
        // clear edit lurking around
        editClaim.value = null;
      } else {
        // clear all
        handleClear();
      }

      // top
      moveToSection("edit");

    };

    // watch qty & price
    const handlePricing = () => {
      amt.value = (Number(qty.value) * Number(standard.value)).toFixed(2);
    };

    // handle reset
    const handleReset = (val) => {
      if (claimsLocked.value) {
        return;
      }

      // revert
      response.value.claims.forEach((x) => {
        if (x.id === val?.id) {
          x.approved_price = x.sent_price;
          x.approved_qty = x.sent_qty;
          x.comment = null;
          x.authorization = "z"; // return to at z
          x.status = "a" // turn to active
        }
      })
    }

    // handle Emitted update
    const handleUpdate = () => {
      if (claimsLocked.value) {
        return;
      }

      if (amt.value && qty.value && claim.value && comment.value) {

        if (editClaim.value) {
          // edit here
          response.value.claims.forEach((x) => {
            if (x.id === editClaim.value?.id) {
              if (Number(amt.value) <= Number(x.sent_price)) { // approved_price // worked!
                x.approved_price = Number(amt.value).toFixed(2);
                x.approved_qty = qty.value;
                x.comment = comment.value;
                x.status = "a" // keep at active
              }
            }
          })
        }
        if (deleteClaim.value) {
          // delete here
          response.value.claims.forEach((x) => {
            if (x.id === deleteClaim.value?.id) {
              x.approved_price = 0;
              x.approved_qty = 0;
              x.comment = comment.value;
              x.authorization = "z"; // return to at z
              x.status = "d" // turn to delete
            }
          })
        }

        // load comments
        restartComments();

      }

      // clear all
      handleClear();

    };

    // hanlde restart
    const handleRestart = () => {
      if (props.inline) {
        context.emit("close", { scheme: encounter.value?.scheme });
        return;
      }

      // Go back Home
      router.push({
        name: "auth"
      });
    };

    // handle auth
    const revealAddAuthPanel = () => {
      const scrollPanelIntoView = () => {
        const target = addAuthPanel.value;

        if (!target) {
          return;
        }

        target.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      };

      setTimeout(scrollPanelIntoView, 140);
      setTimeout(scrollPanelIntoView, 460);
    };

    const handleAddAuth = async () => {
      if (addAuthLocked.value) {
        return;
      }

      addAuth.value = !addAuth.value;
      if (addAuth.value) {
        await nextTick();
        revealAddAuthPanel();
      }
    }

    // handle auth
    const handleAddAuthUpdate = async (val) => {
      if (addAuthLocked.value) {
        return;
      }

      // clear old errors
      error.value = false;

      /* Auth
       Go Back
      */
      if (val?.id === 'clearAuth') {
        // start
        handleAddAuth();
      }

      /* AUTH
        Add New Authorization
        to the server
      */
      if (val?.id === 'addNewAuth') {

        // start
        isSubmitting.value = true;

        // new code (use encounter for newly created)
        let newAuthCode = `${ABBR}-AUTH-${encounter.value.id}-${encounter.value.id}`;

        // update
        let newVal = {
          encounter_id: encounter.value.id,
          item: val.value.claim,
          sent_qty: val.value.qty,
          sent_price: val.value.amt,
          approved_qty: val.value.qty,
          approved_price: val.value.amt,
          standard_price: val.value.standard,
          authorization_code: newAuthCode,
          authorization: "y",
          status: "a",
          slug: store.state.user.slug,
        };

        // post update
        const { res, err } = await postResource.value("claim", newVal);

        if (res.value) {

          // sort
          enrolleeDefault.value.claims.push({
            ...res.value.data,
          });

          // clear
          handleAddAuth();

        } else {
          error.value = err.value;
        }

        // clear
        isSubmitting.value = false;

      }

      // top
      moveToSection("claim");
    }

    // confirmation
    const openApproveConfirm = () => {
      if (isSubmitting.value || claimsLocked.value) {
        return;
      }

      showApproveConfirm.value = true;
    };

    const handleConfirm = (val) => {
      showApproveConfirm.value = false;

      if (claimsLocked.value) {
        return;
      }

      // call submit if confirmed
      if (val) {
        handleSubmit();
      }
    }

    // handle final submit
    const handleSubmit = async () => {
      if (claimsLocked.value) {
        return;
      }

      // start
      isSubmitting.value = true;

      // clean up encounter
      let keysToRemove = ["scheme", "claims", "created_at", "updated_at"];
      let newEncounter = {
        ...Object.fromEntries(
          Object.entries(encounter.value).filter(
            ([key]) => !keysToRemove.includes(key)
          )
        ),
      };

      // newEncounter.payer_id = 1; // this wont be necessary once enrollee is loaded properly

      // setup claims
      let newClaims = [];

      // clean up claims
      encounter.value.claims.forEach((x) => {
        if (x.status === "a" && x.authorization === "z") {
          // load
          newClaims.push({ ...x, authorization: "y", authorization_code: `${ABBR}-AUTH-${x.id}`, slug: store.state.user.slug });
        } else {
          // load
          newClaims.push({ ...x });
        }
      });

      // put all together
      let newVal = { encounter: newEncounter, claims: newClaims };

      // post item
      const endpoint = siloMode ? "claim/update/bulk" : `integration/oneprovider/auth/${encounter.value.id}/decision`;
      const { res, err } = await postResource.value(endpoint, newVal);

      if (res.value) {

        // reset
        resetScrollBar();

        // notify
        M.toast({
          html: "Done <i class='material-icons'>check_circle</i>",
          classes: "green",
          displayLength: 5000,
          inDuration: 300,
          outDuration: 300,
        });

        if (props.inline) {
          context.emit("saved");
          return;
        }

        // fly away!
        handleRestart();


      } else {

        // manage error
        error.value = err.value;
        isSubmitting.value = false; // end

        // reset on fail
        resetScrollBar();

      }

    };

    // output encounter results
    const encounter = computed(() => {
      if (!response.value) {
        return null;
      } else {

        // for pending encounters only
        response.value.claims.forEach((x) => {
          if (!x.approved_price && x.status === "a" && x.authorization === "z") {
            x.approved_qty = x.sent_qty;
            x.approved_price = x.sent_price;
          }
        });

        // return
        return response.value;
      }
    });


    return {
      lock,
      enrolleeDefault,
      capWords,
      toMoney,
      showAgeSex,
      handleRestart,
      handleAddAuth,
      handleAddAuthUpdate,
      handleActive,
      handleActiveState,
      handlePricing,
      handleReset,
      handleReview,
      handleUpdate,
      handleClear,
      openApproveConfirm,
      handleConfirm,
      handleSubmit,
      alertTitle,
      alertMessage,
      selectedItem,
      totalApproved,
      benefitPlanId,
      isReady,
      isLoading,
      isSubmitting,
      home,
      tabs,
      tabsState,
      currTab,
      currState,
      error,
      addAuth,
      addAuthPanel,
      showApproveConfirm,
      editClaim,
      deleteClaim,
      encounter,
      claimsLocked,
      claimsLockLabel,
      encounterAddLocked,
      addAuthLocked,
      addAuthLockLabel,
      standard,
      comment,
      claim,
      qty,
      amt,
    };
  },
};
</script>

<style scoped>
.auth-inline-detail {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 18px 32px -30px rgba(38, 50, 56, 0.72);
  box-sizing: border-box;
  padding: 0;
  position: relative;
  width: 100%;
}

.auth-inline-detail::before {
  background: linear-gradient(180deg, rgba(38, 50, 56, 0.16) 0%, rgba(38, 50, 56, 0.07) 42%, rgba(38, 50, 56, 0) 100%);
  content: "";
  display: none;
  height: 28px;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

.auth-inline-leader,
.auth-inline-switch,
.auth-created-guide,
.auth-inline-review-card,
.auth-inline-secondary-card,
.auth-diagnosis-card,
.auth-inline-items-card,
.auth-inline-add-shell {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.auth-inline-leader {
  align-items: center;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #e1e8eb;
  border-radius: 0;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  padding: 22px 24px;
}

.auth-inline-leader-main {
  align-items: center;
  display: flex;
  gap: 14px;
  min-width: 0;
}

.auth-inline-status {
  align-items: center;
  background: #e8f3f2;
  border: 1px solid #b2dfdb;
  border-radius: 50%;
  color: #00796b;
  display: inline-flex;
  flex: 0 0 auto;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.auth-inline-status.is-waiting {
  background: #ffebee;
  border-color: #ffcdd2;
  color: #b71c1c;
}

.auth-inline-status i {
  font-size: 23px;
}

.auth-inline-leader h5 {
  color: #263238;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.25;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.auth-inline-leader p {
  align-items: center;
  color: #607d8b;
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  gap: 8px;
  margin: 6px 0 0;
}

.auth-inline-leader p strong {
  color: #263238;
}

.auth-inline-meta-chips {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
}

.auth-inline-meta-chips span {
  background: #f8fafb;
  border: 1px solid #e1e8eb;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
  padding: 7px 11px;
}

.auth-inline-meta-chips span.is-locked {
  align-items: center;
  background: #fff8e1;
  border-color: #ffcc80;
  color: #5d4037;
  gap: 5px;
}

.auth-inline-meta-chips span.is-locked i {
  color: #ef6c00;
  font-size: 15px;
  line-height: 1;
}

.auth-inline-dot {
  background: #cfd8dc;
  border-radius: 50%;
  display: inline-block;
  height: 5px;
  width: 5px;
}

.auth-inline-back-action {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: none;
  color: #455a64;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 700;
  min-height: 38px;
  padding: 0 14px;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;
}

.auth-inline-back-action:hover,
.auth-inline-back-action:focus {
  background: #f8fafb;
  box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
  color: #263238;
}

.auth-inline-back-action i {
  color: inherit;
  font-size: 20px;
}

.auth-inline-item-close-action {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  box-shadow: 0 6px 14px -12px rgba(38, 50, 56, 0.75);
  color: #455a64;
}

.auth-inline-item-close-action:hover,
.auth-inline-item-close-action:focus {
  background: #f8fafb;
  box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
  color: #263238;
}

.auth-inline-item-close-action i {
  color: inherit;
}

.auth-inline-close {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d8e2e6;
  border-left: 0;
  border-radius: 999px 6px 6px 999px;
  box-shadow: 0 10px 20px -20px rgba(38, 50, 56, 0.72);
  color: #455a64;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 700;
  min-height: 34px;
  padding: 0 12px 0 0;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, color 160ms ease, transform 160ms ease;
}

.auth-inline-close:hover,
.auth-inline-close:focus {
  background: #f8fafb;
  border-color: #c4d3d9;
  box-shadow: 0 12px 22px -20px rgba(38, 50, 56, 0.82);
  color: #263238;
  transform: translateY(-1px);
}

.auth-inline-close i {
  align-items: center;
  background: #263238;
  border: 1px solid #263238;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  font-size: 18px;
  height: 34px;
  justify-content: center;
  line-height: 1;
  margin-left: -1px;
  margin-right: 9px;
  width: 34px;
}

.auth-inline-close:hover i,
.auth-inline-close:focus i {
  background: #b71c1c;
  border-color: #b71c1c;
}

.auth-inline-switch {
  background: #ffffff;
  border: 0;
  border-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  gap: 0;
  justify-content: center;
  margin: 0;
  max-width: 100%;
  padding: 0 14px !important;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 1;
}

.auth-inline-switch .tab-custom,
.auth-inline-switch .tab-custom-active {
  align-items: center;
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 800;
  justify-content: center;
  line-height: 1.15;
  margin: 0;
  min-height: 46px;
  padding: 0 22px;
  text-transform: uppercase;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.auth-inline-switch .tab-custom {
  background: transparent;
  color: #607d8b;
  box-shadow: none;
}

.auth-inline-switch .tab-custom-active {
  background: transparent;
  border-bottom-color: #263238;
  color: #263238;
  box-shadow: none;
}

.auth-inline-switch .tab-custom:hover {
  background: #f4f7f8;
  color: #263238;
}

.auth-created-guide {
  align-items: center;
  background: linear-gradient(180deg, #fff8e1 0%, #fff3cd 100%);
  border: 1px solid #ffd54f;
  border-radius: 6px;
  box-shadow: 0 12px 22px -24px rgba(121, 85, 72, 0.72);
  display: flex;
  gap: 14px;
  margin: 16px 24px 20px;
  padding: 14px 16px;
}

.auth-created-guide-icon {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(255, 179, 0, 0.55);
  border-radius: 50%;
  color: #00695c;
  display: inline-flex;
  flex: 0 0 auto;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.auth-created-guide-icon i {
  font-size: 22px;
}

.auth-created-guide-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.auth-created-guide-copy span {
  color: #4e342e;
  display: block;
  font-size: 0.82rem;
  font-weight: 900;
  text-transform: uppercase;
}

.auth-created-guide-copy p {
  color: #5d4037;
  line-height: 1.45;
  margin: 4px 0 0;
}

.auth-created-guide-copy strong {
  color: #263238;
}

.auth-created-guide-action {
  align-items: center;
  background: #ffffff;
  border: 1px solid #8d6e63;
  border-radius: 6px;
  color: #4e342e;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.8rem;
  font-weight: 900;
  gap: 7px;
  min-height: 38px;
  padding: 0 13px;
  text-transform: uppercase;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.auth-created-guide-action:hover {
  background: #fffde7;
  border-color: #4e342e;
  color: #263238;
}

.auth-created-guide-action i {
  font-size: 17px;
}

.auth-inline-detail > .section:not(.auth-inline-switch) {
  padding-bottom: 0;
  padding-top: 0;
}

.auth-inline-detail > div > div > .section {
  padding-top: 0;
}

.auth-inline-detail .card {
  border-radius: 6px;
}

.auth-inline-inner-card {
  background: transparent !important;
  border: none;
  box-shadow: none;
  margin: 0;
  padding: 0 !important;
}

.auth-inline-review-card {
  background: #ffffff !important;
  border: 0;
  border-top: 1px solid #e1e8eb;
  border-radius: 0 !important;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0;
  overflow: visible;
  padding: 0 0 20px !important;
  width: 100%;
}

.auth-inline-secondary-card {
  background: #ffffff;
  border: 0;
  border-top: 1px solid #e1e8eb;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  margin: 0;
  overflow: visible;
  padding: 20px !important;
}

.auth-inline-secondary-card :deep(.card) {
  border-bottom: 1px solid #e1e8eb !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 0;
  padding: 0 !important;
}

.auth-inline-secondary-card :deep(.card:last-child) {
  border-bottom: 0 !important;
}

.auth-inline-secondary-card :deep(nav) {
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  box-shadow: none !important;
  margin-bottom: 16px;
  overflow: hidden;
}

.auth-inline-secondary-card :deep(.card-panel) {
  border-bottom: 1px solid #e1e8eb !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 0;
  padding-bottom: 18px !important;
  padding-top: 18px !important;
}

.auth-inline-secondary-card :deep(.card-panel + .card-panel) {
  border-top: 1px solid #ffffff !important;
}

.auth-inline-secondary-card :deep(.card-panel:last-child) {
  border-bottom: 1px solid #e1e8eb !important;
}

.auth-inline-secondary-card :deep(> .card > .card-panel:first-child) {
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}

.auth-inline-secondary-card :deep(> .card > .card-panel:last-child) {
  border-bottom-left-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.auth-diagnosis-card {
  align-items: center;
  background: #f8fafb;
  border: 2px solid #cddde2;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  gap: 14px;
  margin: 20px 20px 0;
  padding: 15px 18px;
}

.auth-diagnosis-icon {
  align-items: center;
  background: #e8f3f2;
  border: 1px solid #cde8e5;
  border-radius: 6px;
  color: #00897b;
  display: inline-flex;
  flex: 0 0 auto;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.auth-diagnosis-icon i {
  font-size: 21px;
}

.auth-diagnosis-copy {
  min-width: 0;
}

.auth-diagnosis-copy span {
  color: #607d8b;
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.auth-diagnosis-copy p {
  color: #263238;
  font-weight: 650;
  line-height: 1.4;
  margin: 0;
  overflow-wrap: anywhere;
}

.auth-diagnosis-copy p.is-muted {
  color: #78909c;
  font-weight: 600;
}

.auth-inline-review-card > .card,
.auth-inline-review-card > .card.grey.lighten-5,
.auth-inline-review-card > .card.teal.lighten-5,
.auth-inline-review-card > .card.red.lighten-5 {
  border: 1px solid #e1e8eb;
  box-shadow: none;
  margin: 18px 20px 0;
}

.auth-inline-review-card > .card.grey.lighten-5 {
  background: #ffffff !important;
}

.auth-inline-review-card > .auth-inline-items-card {
  box-sizing: border-box;
  margin-left: 20px;
  margin-right: 20px;
  max-width: calc(100% - 40px);
  width: auto;
}

.auth-inline-review-card .card-content {
  color: #263238;
}

.auth-inline-review-card .card-title {
  color: #263238;
  font-size: 1.05rem;
  font-weight: 700;
}

.auth-inline-review-card .collection {
  border-color: #e1e8eb;
  border-radius: 6px;
  overflow: hidden;
}

.auth-inline-review-card .collection-item {
  border-bottom-color: #edf2f4;
  line-height: 1.45;
}

.auth-inline-review-card .auth-line-item {
  box-sizing: border-box;
  min-height: 54px;
  padding-right: 126px;
  position: relative;
}

.auth-inline-review-card .auth-line-copy {
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: break-word;
}

.auth-inline-review-card .line-item-actions {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.auth-inline-review-card .line-item-actions .secondary-content {
  float: none;
  margin-left: 0;
  position: static;
}

.auth-inline-review-card .line-item-actions a {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  position: relative;
  width: 30px;
}

.auth-inline-review-card .line-item-actions a + a::before {
  background: #c4d3d9;
  content: "";
  height: 20px;
  left: -3px;
  position: absolute;
  top: 5px;
  width: 1px;
}

.auth-inline-review-card .line-item-actions i {
  line-height: 1;
}

.auth-inline-review-card .collection-item.pull-right {
  background: #f8fafb;
  color: #263238;
}

.auth-inline-add-shell {
  box-sizing: border-box;
  margin: 8px 20px 0;
  max-width: calc(100% - 40px);
  overflow: visible;
  position: relative;
  z-index: 10;
}

.auth-inline-add-shell :deep(.card) {
  background: #ffffff !important;
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  box-shadow: none;
  box-sizing: border-box;
  margin: 0;
  overflow: visible;
  width: 100%;
}

.auth-inline-add-shell :deep(.card-content) {
  box-sizing: border-box;
  padding: 22px;
}

.auth-inline-add-shell :deep(.row) {
  margin-left: 0;
  margin-right: 0;
}

.auth-inline-add-shell :deep(form.col.s12) {
  padding-left: 0;
  padding-right: 0;
}

.auth-inline-add-shell :deep(.add-auth-item-card),
.auth-inline-add-shell :deep(.add-auth-item-card .card-content),
.auth-inline-add-shell :deep(.add-auth-item-card form),
.auth-inline-add-shell :deep(.add-auth-item-card .row),
.auth-inline-add-shell :deep(.add-auth-item-card .input-field) {
  overflow: visible !important;
}

.auth-inline-add-shell :deep(.add-auth-item-card) {
  position: relative;
  z-index: 20;
}

.auth-inline-add-shell :deep(.add-auth-item-card .autocomplete-content.dropdown-content) {
  max-height: 320px;
  overflow-y: auto;
  z-index: 1200;
}

.auth-add-slide-enter-active,
.auth-add-slide-leave-active {
  overflow: hidden;
  transition:
    max-height 0.42s ease,
    opacity 0.26s ease,
    transform 0.42s ease;
}

.auth-add-slide-enter-from,
.auth-add-slide-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

.auth-add-slide-enter-to,
.auth-add-slide-leave-from {
  max-height: 620px;
  opacity: 1;
  transform: translateY(0);
}

.progress {
  margin-top: -15px;
}

.spacer5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.spacerTop10 {
  padding-top: 10px;
  padding-bottom: 0px;
}

.edit-black-item:hover .material-icons.black-text,
.edit-black-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.cancel-item:hover .material-icons.grey-text,
.cancel-item:hover .material-icons.grey-text::before {
  color: rgb(214, 16, 16) !important;
}

.custom-nav {
  height: 15px;
}

.nav-extended .nav-wrapper {
  padding: 0 20px;
}

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}

@media only screen and (max-width: 992px) {
  .auth-inline-detail {
    background: transparent;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .auth-inline-leader {
    border: 1px solid #e1e8eb;
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 18px;
  }

  .auth-inline-switch {
    align-items: stretch;
    flex-wrap: wrap;
    gap: 0;
    justify-content: center;
    padding: 0 14px !important;
  }

  .auth-inline-switch .tab-custom,
  .auth-inline-switch .tab-custom-active {
    background: transparent;
    border: 0;
    border-bottom: 3px solid transparent;
    border-radius: 0;
    box-sizing: border-box;
    color: #607d8b;
    float: none !important;
    flex: 0 0 auto;
    font-size: 0.82rem;
    justify-content: center;
    min-height: 46px;
    padding: 0 22px;
    text-align: center;
  }

  .auth-inline-switch .tab-custom-active {
    background: transparent;
    border-bottom-color: #263238;
    color: #263238;
  }

  .auth-inline-switch .tab-custom:hover {
    background: #f4f7f8;
    color: #263238;
  }

  .auth-inline-detail > .section:not(.auth-inline-switch),
  .auth-inline-detail > div > div > .section {
    padding: 0;
  }

  .auth-inline-inner-card,
  .auth-inline-review-card {
    background: transparent !important;
    border: 0;
    box-shadow: none;
  }

  .auth-inline-review-card {
    padding: 0 0 16px !important;
  }

  .auth-diagnosis-card,
  .auth-inline-review-card > .card,
  .auth-inline-review-card > .card.grey.lighten-5,
  .auth-inline-review-card > .card.teal.lighten-5,
  .auth-inline-review-card > .card.red.lighten-5,
  .auth-inline-review-card > .auth-inline-items-card {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    width: 100%;
  }

  .auth-inline-add-shell {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }

  .auth-inline-review-card .auth-line-item {
    padding-right: 20px;
  }

  .auth-inline-review-card .auth-line-copy {
    padding-right: 0;
  }

  .auth-inline-review-card .line-item-actions {
    background: #f8fafb;
    border: 1px solid #dbe5e9;
    border-radius: 999px;
    box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
    gap: 10px;
    margin-left: 10px;
    margin-top: 10px;
    padding: 4px;
    position: static;
    transform: none;
    width: max-content;
  }

  .auth-inline-review-card .auth-line-copy .info-item:not(.secondary-content) {
    display: inline-flex;
    margin-right: 10px;
    position: relative;
    top: -0.35em;
    vertical-align: super;
  }

  .auth-inline-review-card .auth-line-copy .info-item:not(.secondary-content) i {
    line-height: 1;
  }

  .auth-inline-review-card .line-item-actions a {
    height: 34px;
    width: 34px;
  }

  .auth-inline-review-card .line-item-actions a + a::before {
    display: none;
  }

  .auth-inline-review-card .line-item-actions .tiny.material-icons {
    font-size: 1.25rem;
  }

  .auth-inline-review-card .auth-inline-back-action,
  .auth-inline-item-close-action {
    display: block;
    flex: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
    min-height: 0;
    padding: 0 16px;
    text-align: center;
  }

  .auth-inline-review-card .auth-inline-back-action i.left,
  .auth-inline-item-close-action i.left {
    line-height: 36px;
  }
}

@media only screen and (max-width: 600px) {
  .auth-inline-detail {
    padding: 0;
  }

  .auth-inline-leader {
    align-items: flex-start;
    flex-direction: column;
    padding: 16px;
  }

  .auth-inline-switch .tab-custom,
  .auth-inline-switch .tab-custom-active {
    margin-bottom: 0;
  }

  .auth-created-guide {
    align-items: flex-start;
    flex-direction: column;
    margin: 10px 0;
  }

  .auth-created-guide-action {
    justify-content: center;
    width: 100%;
  }

  .auth-inline-add-shell {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }

  .auth-diagnosis-card {
    padding: 12px 14px;
  }

  .auth-inline-review-card .card-content {
    padding: 16px;
  }

  .auth-inline-review-card .collection-item {
    padding: 12px 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .auth-inline-leader,
  .auth-inline-switch,
  .auth-created-guide,
  .auth-inline-review-card,
  .auth-inline-secondary-card,
  .auth-diagnosis-card,
  .auth-inline-items-card,
  .auth-inline-add-shell {
    animation: none;
  }
}
</style>

<style>
.auth-inline-confirm-layer {
  align-items: center;
  background: rgba(20, 31, 38, 0.62);
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed !important;
  right: 0;
  top: 0;
  z-index: 10050;
}

.auth-inline-confirm-card {
  background: #ffffff;
  border: 1px solid #dbe5e9;
  border-radius: 6px;
  box-shadow: 0 24px 56px rgba(25, 35, 42, 0.34);
  max-width: calc(100vw - 48px);
  overflow: hidden;
  width: 710px;
}

.auth-inline-confirm-content {
  padding: 34px 30px 28px;
}

.auth-inline-confirm-content h4 {
  color: #263238;
  font-size: 2rem;
  font-weight: 400;
  margin: 0 0 20px;
}

.auth-inline-confirm-content p {
  color: #263238;
  font-size: 1rem;
  line-height: 1.45;
  margin: 0;
}

.auth-inline-confirm-actions {
  align-items: center;
  border-top: 1px solid #eef2f4;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 12px 20px;
}

.auth-inline-confirm-actions button {
  background: transparent;
  border: 0;
  color: #263238;
  cursor: pointer;
  font-size: 0.86rem;
  font-weight: 500;
  padding: 9px 13px;
  text-transform: uppercase;
}

.auth-inline-confirm-actions button:hover {
  background: #f3f6f7;
}
</style>
